// extracted by mini-css-extract-plugin
module.exports = {"datafileWrapper":"datafileWrapper--Datafile-components__Nqexn","classNameByType":"classNameByType--Datafile-components__1T0W0"};